import { render, staticRenderFns } from "./companySales.vue?vue&type=template&id=8426558a"
import script from "./companySales.vue?vue&type=script&lang=js"
export * from "./companySales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports